import { Component, Vue, toNative } from "vue-facing-decorator";
import lscache from "lscache";

/**
 * Check if we have a valid help content
 * @param url The full path url of the external help content
 * @param cbHelpExists Callback function to set the help source status response (true/false)
 */
export function checkHelpSource(url: string, cbHelpExists: any) {
  if (!cbHelpExists || typeof cbHelpExists !== "function") {
    return;
  }

  // Make sure we are only sending url check request for base path not including any hash or params
  let baseUrl = url;
  if (typeof URL === "function") {
    try {
      const base = new URL(baseUrl);
      baseUrl = base.origin + base.pathname;
    } catch (e) {
      return;
    }
  }
  const cachedCheck = lscache.get(baseUrl);
  if (cachedCheck != null) {
    cbHelpExists(cachedCheck === "true");
  } else {
    try {
      let request;
      if (window["XMLHttpRequest"]) {
        request = new XMLHttpRequest();
      } else {
        request = new ActiveXObject("Microsoft.XMLHTTP");
      }

      request.open("HEAD", baseUrl, true);
      request.onreadystatechange = function (evt) {
        if (
          (this.readyState === 4 || this.readyState === 2) &&
          this.status === 200
        ) {
          //if Headers ready or all done
          lscache.set(baseUrl, "true", 5);
          cbHelpExists(true);
        } else {
          lscache.set(baseUrl, "false", 5);
          cbHelpExists(false);
        }
      };
      request.send();
    } catch (err) {
      lscache.set(baseUrl, "false", 5);
    }
  }
}

@Component
export class PageHelpMixin extends Vue {
  helpDrawer: boolean = false;
  helpUrl: string | null | undefined = null;
  helpSourceId: string | null | undefined = null;
  helpSourceTitle: string | null | undefined = null;
  sectionHelp: boolean = false;

  closeHelp(defaultUrl: string) {
    this.resetPageHelp(defaultUrl);
  }

  showHelp(detail: {
    url: string;
    sourceId: string;
    sourceTitle: string;
    sectionHelp: boolean;
  }) {
    if (detail) {
      this.helpDrawer = true;
      this.helpUrl = detail.url;
      this.helpSourceId = detail.sourceId;
      this.helpSourceTitle = detail.sourceTitle;
      this.sectionHelp = detail.sectionHelp;
    }
  }

  initPageHelp(defaultUrl: string) {
    this.resetPageHelp(defaultUrl);
    this.addPageHelpEventHandler();
  }

  resetPageHelp(defaultUrl: string) {
    this.helpDrawer = false;
    this.helpUrl = defaultUrl;
    this.helpSourceId = null;
    this.helpSourceTitle = null;
    this.sectionHelp = false;
  }

  public addPageHelpEventHandler() {
    const _t = this;
    document.addEventListener("ui-show-page-help", function (event: any) {
      _t.showHelp(event.detail);
    });
  }
}

export default toNative(PageHelpMixin);
